module.exports = __webpack_public_path__ + "img/product_standard_active_mobile.38df18dd.png";